<div class="cookie-consent" *ngIf="!cordova && canShowCookiesMsg">
  <div>
    {{ 'component.toast.cookies_message' | translate }}
    <a href="#" (click)="openPrivacyPolicy()">{{ 'component.toast.find_out_more' | translate }}</a>
  </div>
  <div>
    <div class="cookie-consent__ok-btn" (click)="closeCookies()">OK</div>
  </div>
</div>